import { Component } from 'preact';
import style from './styles/RaffleSizeSelect.scss';
import { CLIENT } from '../../parameters';

/**
 * @property {RaffleSize[]}   props.sizes      Raffle sizes to choose from
 * @property {value}          props.value      Size id
 * @property {Function}       props.onChange   Callback
 * @property {boolean}        state.open       Is select open?
 */
export default class RaffleSizeSelect extends Component {
	state = {
		open: false
	};

	open = () => {
		this.setState({ open: true });
	};

	close = () => {
		this.setState({ open: false });
	};

	toggle = () => {
		this.setState((prevState) => ({ open: !prevState.open }));
	};

	onChange = (id) => {
		this.props.onChange(id);
		this.close();
	};

	/**
	 * Set the wrapper ref
	 */
	setContainerRef = (node) => {
		this.containerRef = node;
	};

	/**
	 * Close select if we click outside of the container
	 */
	handleClickOutside = (event) => {
		if (this.containerRef && !this.containerRef.contains(event.target)) {
			this.close();
		}
	};

	componentDidMount() {
		if (CLIENT) {
			document.addEventListener('mousedown', this.handleClickOutside);
		}
	}

	componentWillUnmount() {
		if (CLIENT) {
			document.removeEventListener('mousedown', this.handleClickOutside);
		}
	}

	render ({ sizes, value, text }, { open }, context) {

		/** @type RaffleSize */
		const selectedRaffleSize = sizes.find((raffleSize) => raffleSize.id === value);
		const isOpenClass = open ? ' ' + style.open : '';

		return (
			<div className={style['raffle-size-select'] + isOpenClass} ref={this.setContainerRef}>
				<div className={style.control + isOpenClass} onClick={this.toggle}>
					{ selectedRaffleSize ? (
						<div className={`row ${style['selected-size']}`}>
							<div className="col-auto"><span>US:</span> {selectedRaffleSize.us}</div>
							<div className="col-auto"><span>EUR:</span> {selectedRaffleSize.eur}</div>
							<div className="col-auto"><span>UK:</span> {selectedRaffleSize.uk}</div>
							<div className="col-auto"><span>CM:</span> {selectedRaffleSize.cm}</div>
						</div>
					) : (
						<span className={style['default-text']}>{text}</span>
					)}
				</div>
				{ open === true ? (
					<div className={style.options} >
						<div className={`row ${style.header}`}>
							<div className="col-3">US</div>
							<div className="col-3">EUR</div>
							<div className="col-3">UK</div>
							<div className="col-3">CM</div>
						</div>
						{ sizes.map((raffleSize, index) => <RaffleSizeOption {...{ raffleSize, onChange: this.onChange, className: index === 0 ? style.first : '' }} />) }
					</div>
				) : null }
			</div>
		);
	}
}

/**
 * @property {RaffleSize}   props.raffleSize   Raffle size
 * @property {string}       props.className    Extra class name for row
 * @property {Function}     props.onChange     Callback
 */
class RaffleSizeOption extends Component {
	onChange = () => {
		this.props.onChange(this.props.raffleSize.id);
	};

	render(props, state, context) {
		const raffleSize = props.raffleSize;
		const className = 'row' + (props.className ? ` ${props.className}` : '');
		return (
			<div className={className} onClick={this.onChange}>
				<div className="col-3">{raffleSize.us}</div>
				<div className="col-3">{raffleSize.eur}</div>
				<div className="col-3">{raffleSize.uk}</div>
				<div className="col-3">{raffleSize.cm}</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/form/RaffleSizeSelect.js